import { Controller } from "@hotwired/stimulus"

// Search + quicklink-category picker for the award design catalog, replacing
// a plain <select>. Selecting a card writes its id into the hidden
// popular_award_id field the form already submits -- everything downstream
// (server-side validation, request creation) is unchanged.
export default class extends Controller {
  static targets = ["search", "category", "card", "selection", "empty"]

  connect() {
    this.activeCategoryId = "all"

    // Restore the selected card on load -- most commonly a re-render after a
    // validation error elsewhere in the form (e.g. notes too long). The
    // hidden field already carries the right award id (Rails re-populates it
    // from the model), but nothing marked its card as selected, so the page
    // looked like the choice had been lost even though it would still submit
    // correctly.
    if (this.selectionTarget.value) {
      const selected = this.cardTargets.find((card) => card.dataset.awardId === this.selectionTarget.value)
      if (selected) selected.classList.add("award-catalog__card--selected")
    }
  }

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.cardTargets.forEach((card) => {
      const matchesTitle = !term || card.dataset.title.includes(term)
      const matchesCategory = this.activeCategoryId === "all" || card.dataset.categoryId === this.activeCategoryId
      const visible = matchesTitle && matchesCategory

      card.hidden = !visible
      if (visible) visibleCount += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visibleCount > 0
  }

  selectCategory(event) {
    this.activeCategoryId = event.currentTarget.dataset.categoryId

    this.categoryTargets.forEach((button) => {
      button.classList.toggle("is-active", button === event.currentTarget)
    })

    this.filter()
  }

  selectAward(event) {
    const card = event.currentTarget
    this.selectionTarget.value = card.dataset.awardId

    this.cardTargets.forEach((c) => {
      c.classList.toggle("award-catalog__card--selected", c === card)
    })
  }
}
